import React from "react";
import { Trans } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { PATHNAMES_KEYS } from "../../helpers/history";

export const NavBar = () => {
  const { pathname } = useLocation();
  const thirdLink = [
    "/application/create/pos",
    "/application/create/ecomerce",
    "/application/create/cashback",
    "/application/create/billing",
  ];

  return (
    <div className="lb-breadcrumb">
      <div className="container-breadcrumb">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link className="breadcrumb-link" to="/">
                <Trans i18nKey="Menu.Main" />
              </Link>
              <span className="ml-8">/</span>
            </li>

            {PATHNAMES_KEYS[pathname] && (
              <li
                className={`breadcrumb-item ${
                  !thirdLink.includes(pathname)
                    ? " breadcrumb-item-active "
                    : ""
                }`}>
                <Link
                  className="breadcrumb-link"
                  to={
                    thirdLink.includes(pathname)
                      ? pathname.includes("ecomerce")
                        ? "/e-commerce"
                        : "/" +
                          pathname.split("/")[pathname.split("/").length - 1]
                      : "#"
                  }>
                  <Trans i18nKey={`NavBar.${PATHNAMES_KEYS[pathname]}`} />
                </Link>
                {thirdLink.includes(pathname) && (
                  <span className="ml-8">/</span>
                )}
              </li>
            )}

            {thirdLink.includes(pathname) && (
              <li
                className="breadcrumb-item breadcrumb-item-active"
                aria-current="page">
                <Link className="breadcrumb-link" to="#">
                  <Trans i18nKey={"NavBar.ApplicationCreate"} />
                </Link>
              </li>
            )}
          </ol>
        </nav>
      </div>
    </div>
  );
};
